import { render } from "./ActAsBanner.vue?vue&type=template&id=6c6ad463"
import script from "./ActAsBanner.vue?vue&type=script&lang=js"
export * from "./ActAsBanner.vue?vue&type=script&lang=js"

import "./ActAsBanner.vue?vue&type=style&index=0&id=6c6ad463&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__